import { IObservable, Subject } from '~/rage/utils';
import {
	IButtonActionsService,
	IButtonActionState,
} from './buttonActionsServiceTypes';

export const ACTION_KEY_FORMAT = '{key_[0-9]+}';

export abstract class AbstractButtonActionsService
	implements IButtonActionsService
{
	protected availableActions: IButtonActionState[] = [];
	protected currentAction = new Subject<IButtonActionState | null>(null);

	public getDisplayedAction(): IObservable<IButtonActionState | null> {
		return this.currentAction;
	}

	public showAction(id: string, text: string, button: string): void {
		const currentAction = this.currentAction.getValue();

		if (currentAction) {
			this.availableActions.push(currentAction);
		}

		this.currentAction.next({ id, text, button });
	}

	public hideAction(id: string): void {
		if (this.availableActions.find((e) => e.id === id)) {
			this.availableActions = this.availableActions.filter((e) => e.id !== id);
		}

		const currentAction = this.currentAction.getValue();
		if (!currentAction) {
			return;
		}

		if (currentAction.id !== id) {
			return;
		}

		this.currentAction.next(this.availableActions.pop() ?? null);
	}
}
